// extracted by mini-css-extract-plugin
export default {"breadcrub_container":"index_breadcrub_container__Od0Ik","createdSearch":"index_createdSearch__bVNfV","custom_table":"index_custom_table__5CXQW"};